import type { UserPid } from '@/features/auth/services/oidc';
import { fastApi } from '@/services/api';
import type { UserSegment } from '@/types/user';
import type { AccountType } from '@/utils/account-type';

const PATH = 'v1/user';

type UserAttributesVerified = 'unverified' | 'started' | 'verified';

export type UserAttributes = {
  TwoFA: boolean | undefined;
  account_holder: string;
  account_status: string | undefined;
  currency: string | undefined;
  email: string | undefined;
  firstname: string | undefined;
  residence_country_iso: string | undefined;
  segment: UserSegment | undefined;
  surname: string | undefined;
  verified: UserAttributesVerified | undefined;
  verification_date: {
    unix: number | undefined;
    date_iso8601: string | undefined;
  };
};

type User = {
  type: 'user';
  id: string;
  attributes: UserAttributes;
};

type GetUserResponse = {
  data: {
    type: 'collection';
    attributes: {
      user: [User];
    };
  };
};

type PutUserRequestBody = {
  accountType: AccountType;
};

const getUser = (pid: UserPid) => {
  return fastApi.get(`${PATH}/${pid}`).json<GetUserResponse>();
};

export const putUser = (body: PutUserRequestBody) => {
  return fastApi.put(PATH, { json: body }).json();
};

export const getUserAttributes = async (pid: UserPid) => {
  const user = await getUser(pid);

  return user.data.attributes.user[0].attributes;
};
